'use strict';

var _ = require('underscore/underscore');
var SubSection = require('front/pages/Section/SubSection');

var template = require('./BasePopup.jinja');
require('./BasePopup.less');

var Utils = require('front/utils/Utils');

module.exports = SubSection.extend({
    template: template,

    el: '.BasePopup',

    mainContentSelector: '.BasePopup-wrapper',

    baseEvents: {
        'click .BasePopup-close': 'close'
    },


    apiUrl: function () {
        return undefined;
    },


    initialize: function (options) {
        SubSection.prototype.initialize.call(this, options);

        _.bindAll(this, 'apiUrl', 'onKeydown', 'onResize', 'keyDownOn', 'keyDownOff');

        $(window).on('resize', this.onResize);

        if (options.server) {
            this.triggerPopupShown();
            this.$('.BasePopup-content').scrollTop(0);
            this.$('.BasePopup-content').focus(); //for pgdn pgup shortcuts
            this.fromServer = true;

            this.data = {}; //prevent api call for data when opens from direct url
        }

        this.keyDownOn();
    },


    onResize: function () {
        // this.$('.BasePopup-content').css('min-height', window.innerHeight);
    },


    keyDownOn: function () {
        $(window).on('keydown', this.onKeydown);
    },


    keyDownOff: function () {
        $(window).off('keydown', this.onKeydown);
    },


    onKeydown: function (e) {
        if (e.keyCode === 27) { //esc
            this.close();
        }
    },


    triggerPopupShown: function () {
        this.savedScroll = $(window).scrollTop();
        app.vent.trigger('PopupShown');
        if (window.app.settings.isSafari && window.app.settings.isDesktop) {
            requestAnimationFrame(() => {
                $(window).scrollTop(0);
            });
        } else {
            $(window).scrollTop(0);
        }
        this.$el.addClass('BasePopup--animation-in-progress');
    },


    triggerPopupHidded: function () {
        if (window.app.settings.isSafari && window.app.settings.isDesktop) {
            $(window).scrollTop(this.savedScroll);
            app.vent.trigger('PopupHidded');
        } else {
            app.vent.trigger('PopupHidded');
            $(window).scrollTop(this.savedScroll);
        }
        this.$el.removeClass('BasePopup--animation-in-progress');
    },


    close: function () {
        app.router.navigateBack();
    },


    activate: function (params) {
        return SubSection.prototype.activate.call(this, params)
            .then(function () {
                this.$content = this.$('.BasePopup-content');
            }.bind(this));
    },

    //on animation end
    onPopupShown: function () {
        this.$el.removeClass('BasePopup--animation-in-progress');
    },


    //on animation end
    onPopupHidded: function () {
        this.$el.addClass('BasePopup--animation-in-progress');
    },


    playIn: function (params) {
        var self = this;
        clearTimeout(self.popupShowAnimationTimeout);
        clearTimeout(self.popupShowResolveTimeout);

        if (this.options.inAnimated) {
            return new Promise(function (resolve) {
                if (params.duration) {
                    self.$el.outerHeight();
                    self.onResize();
                    self.triggerPopupShown();

                    //to fix animation gliches while content load
                    self.popupShowAnimationTimeout = setTimeout(function () {
                        self.$el.addClass('BasePopup--visible');
                    }, 220);

                    self.popupShowResolveTimeout = setTimeout(function () {
    //                    this.$('.BasePopup-content').focus();//for keys pgup, pgdown etc to scroll popup, not global
                        self.onPopupShown();
                        resolve();
                    }, params.duration + 220);
                } else {
                    self.$el.hide();
                    self.$el.addClass('BasePopup--visible');
                    self.$el.outerHeight();
                    self.onResize();
                    self.$el.show();
                    self.triggerPopupShown();
                    self.onPopupShown();
                    resolve();
                }
            });
        } else {
            self.onPopupShown();

            return Utils.createEmptyPromise();
        }
    },


    playOut: function (params) {
        var self = this;

        clearTimeout(self.popupShowAnimationTimeout);
        clearTimeout(self.popupShowResolveTimeout);

        return new Promise(function (resolve) {
            self.$el.removeClass('BasePopup--visible');
            self.onPopupHidded();

            if (params.duration) {
                app.utils.waitForTransitionEnd(self.$('.BasePopup-wrapper'), 'transform', function () {
                    self.triggerPopupHidded();
                    resolve();
                }.bind(this), params.duration);
            } else {
                self.triggerPopupHidded();
                resolve();
            }
        });
    },

    freeze: function () {
        var self = this;

        clearTimeout(self.popupShowAnimationTimeout);
        clearTimeout(self.popupShowResolveTimeout);

        return new Promise(function (resolve) {
            self.$el.css('top', self.$el.offset().top - app.sizes.scrollTop).addClass('FixedOnPopup');

            setTimeout(function () {
                self.triggerPopupHidded();
            }, 17);

            setTimeout(function () {
                resolve();
            }, 30);
        });
    },


    viewsRegistration: function () {
        this.onResize();

        if (this.fromServer) {
            this.onPopupShown();
        } else {
            this.$el.removeClass('BasePopup--visible');
        }

        SubSection.prototype.viewsRegistration.call(this);
    },


    destroy: function () {
        this.keyDownOff();
        $(window).off('resize', this.onResize);

        return SubSection.prototype.destroy.call(this);
    },


    deactivate: function (params) {
        this.triggerPopupHidded();

        return SubSection.prototype.deactivate.call(this, params);
    }
});
